import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./contactform.css";

const ContactForm = () => {
  const form = useRef();
  const [statusMessage, setStatusMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    setStatusMessage("Sending...");

    emailjs
      .send(
        "service_l56hhk6",
        "devtechinvento-contact",
        formData,
        { publicKey: "Jhd4_9ZrourO4fGDR" }
      )
      .then(
        (result) => {
          setStatusMessage("Thanks for your message! We will get back to you soon.");
          form.current.reset();
          setFormData({
            name: "",
            email: "",
            phone: "",
            subject: "",
            message: ""
          });
        },
        (error) => {
          setStatusMessage("Failed to send message. Try again.");
        }
      );
  };

  return (
    <div className="contact-wrap">
      <h2>Contact Me</h2>
      <p className="sub">Have a project or role in mind? Send a message and I'll get back to you.</p>
      <form ref={form} onSubmit={sendEmail}>
        <div className="field">
          <label>Your Name</label>
          <input type="text" name="name" required value={formData.name} onChange={handleChange} placeholder="Enter your name" />
        </div>
        <div className="field">
          <label>Your Email</label>
          <input type="email" name="email" required value={formData.email} onChange={handleChange} placeholder="Enter your email" />
        </div>
        <div className="field">
          <label>Your Phone Number (Optional)</label>
          <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Enter your phone number" />
        </div>
        <div className="field">
          <label>Subject</label>
          <input type="text" name="subject" required value={formData.subject} onChange={handleChange} placeholder="Enter your subject" />
        </div>
        <div className="field">
          <label>Your Message (Optional)</label>
          <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Enter your message" />
        </div>
        <button className="btn btn-primary" type="submit">Send Message</button>
      </form>
      {statusMessage && <p className="status-message">{statusMessage}</p>}
    </div>
  );
};

export default ContactForm;
